import React, {Component} from 'react';
import {Link, Redirect} from "react-router-dom";
import $ from 'jquery';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import ContentLoader from'./contentLoader';
import ProductStoreDetails from "./ProductStoreDetails";


class StoreDetails extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            studioUrl: this.decryptconfigdata('studioUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            products: [],
            customer_details: [],
            billing_details: [],
            cards_list: [],
            applications: [],
            account_manager: {},
            content_analytics: [],
            logo: '',
            get_billing_api: 0,
            get_content_api: 0,
            app_token: '',
            store_key: '',
            selected_product_key: '',
            selected_products: []
        };
    }
    
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;
    }
   
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
    }
    
    handleAccountManager = (data) => {
    this.setState({ account_manager: data });
    }

    getRecentLogo() {
        if (this.state.logo != '') {
     return  <img src={this.state.logo} alt='Logo' class='store-logo'/>;  
        } else {
     return <img src='' alt='Logo' class='store-logo'/>;
     } 
    }
    
    getLogo() {
        let columnsfetch = {
          "email": this.state.customer_details.email,
          "name": this.state.customer_details.name
        };
            fetch(this.state.apiUrl + '/crmRest/getLogo/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(columnsfetch),

            }).then((Response) => Response.json())
                .then((findresponse) => {
                   if (findresponse.code == 200) {
                            this.setState({
                                logo: findresponse.logo,
                            })
                        }
                })
    }
    
    getAllStoreDetails() {
        var appToken = this.props.match.params.appToken;

        let columnsfetch = {
            "app_token": appToken
        };
                    
        fetch('https://apigateway.muvi.com/crm-data', {
                method: 'POST',
                dataType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `{getCrmData(app_token: "${appToken}") {page_info{total_count}, user_details {domain_name,name, email, mobile, company_name, ip_address, country_name, number_of_login, region_name, city_name, address, app_token, user_uuid, store_key, created_date, source,products{product_key, product_name, customer_type, subadmin_count, is_enterprise , enterprise_api_gateway_url,total_no_of_users,total_no_of_subscribed_users, subadmin_details{name, email}}}}}`
            })
        })
                    .then((Response) => Response.json())
                .then((findresponse) => {
                   if (findresponse.code == 200) {
                            this.setState({
                            customer_details: findresponse.data.getCrmData.user_details,
                            products: findresponse.data.getCrmData.user_details.products,
                            selected_product_key: findresponse.data.getCrmData.user_details.products[0].product_key,
                            selected_products: findresponse.data.getCrmData.user_details.products[0],
                            app_token: appToken
                            })
                        }
                            })
                .then(() => {
                            this.getLogo();
                })
    }
                     
    componentDidMount()
    {
        document.title = "Intranet | Customer Details";
        if (!localStorage.getItem('userLogin')) {
            this.setState({redirect: true});
        }
        this.getAllStoreDetails();
    }
    
    handleTabClick = (product) => {
        this.setState({selected_product_key: product.product_key});
        this.setState({selected_products: product});
        this.productStore();
    }

    productStore() {
            return(   
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active" id="one">
                        <div class="row">
                            <ProductStoreDetails products={this.state.selected_products} product_key={this.state.selected_product_key} app_token={this.state.app_token} store_key={this.state.customer_details.store_key} source = {this.state.customer_details.source} user_uuid={this.state.customer_details.user_uuid} number_of_login={this.state.customer_details.number_of_login} account_manager={this.state.account_manager} getAccountManager={this.handleAccountManager}/>
                        </div>
                    </div>
                </div>
            )
        }
    
    render() {
        if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
          }
        return (
            <div>
            <Header brecum_name="Customer" brecum_page="Customers Details"/>
         <div className="right_col">
        <div class="title mob hidden-md">
            <HeaderMob page_name="Customer Details"/>
        </div>
        <section class="store-section">
                {!this.state.customer_details ? <div>Something Went Wrong!</div> :
                <div class="customer-details-area container" id="exTab1" >
                <ul class="nav nav-pills">
                            <li class="active">
                                <a  href="#CustomersInfo" data-toggle="tab">General Info</a>
                            </li>
                            <li><a href="#AppInfo" data-toggle="tab">App Info</a>
                            </li>
                            <li><a href="#Login" data-toggle="tab">Login</a>
                            </li>
                            <li><a href="#Upload" data-toggle="tab">Upload</a>
                            </li>
                        </ul>
                        {this.state.customer_details.length == 0 ?
                        <ContentLoader/>
                        :
                        <div class="tab-content customer-tab clearfix">        
                        <div class="tab-pane active" id="CustomersInfo">       
                <div class="top-area">
                    <div class="profile-area">
                        <div class="profile-left">
                            <div class="img-box"> 
                              {this.getRecentLogo()}
                            </div>
                            <div class="text-area">
                                <div class="name cap-text">{this.state.customer_details.company_name ? this.state.customer_details.company_name : 'NA'}</div>
                                <div class="email">{this.state.customer_details.domain_name && this.state.customer_details.domain_name != 'NA' ? <Link to={`http://${this.state.customer_details.domain_name}`} name={"max"} target="_blank"> {this.state.customer_details.domain_name} </Link> : ''}</div>
                            </div>
                        </div>
                    </div>
                    <div class="contact-information-area">
                        <div class="store-title">Contact Information</div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2 6.00001L8 1.33334L14 6.00001V13.3333C14 13.687 13.8595 14.0261 13.6095 14.2762C13.3594 14.5262 13.0203 14.6667 12.6667 14.6667H3.33333C2.97971 14.6667 2.64057 14.5262 2.39052 14.2762C2.14048 14.0261 2 13.687 2 13.3333V6.00001Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M6 14.6667V8H10V14.6667" fill="#52B7ED"></path>
                                            <path d="M6 14.6667V8H10V14.6667" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Company Name</div>
                                                                                            <div class="bottom-text cap-text">{this.state.customer_details.company_name ? this.state.customer_details.company_name : 'NA'}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.9997 14V12.6667C13.9997 11.9594 13.7187 11.2811 13.2186 10.781C12.7185 10.281 12.0403 10 11.333 10H5.99967C5.29243 10 4.61415 10.281 4.11406 10.781C3.61396 11.2811 3.33301 11.9594 3.33301 12.6667V14" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.66667 7.33333C10.1394 7.33333 11.3333 6.13943 11.3333 4.66667C11.3333 3.19391 10.1394 2 8.66667 2C7.19391 2 6 3.19391 6 4.66667C6 6.13943 7.19391 7.33333 8.66667 7.33333Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">User Name</div>
                                        <div class="bottom-text cap-text">{this.state.customer_details.name ? this.state.customer_details.name : 'NA'}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.00033 2.66666H13.667C14.4003 2.66666 15.0003 3.26666 15.0003 3.99999V12C15.0003 12.7333 14.4003 13.3333 13.667 13.3333H3.00033C2.26699 13.3333 1.66699 12.7333 1.66699 12V3.99999C1.66699 3.26666 2.26699 2.66666 3.00033 2.66666Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M15.0003 4L8.33366 8.66667L1.66699 4" fill="#52B7ED"></path>
                                            <path d="M1.66699 4L8.33366 8.66667L15.0003 4H1.66699ZM1.66699 4L3.00037 3" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Email ID</div>
                                        <div class="bottom-text">{this.state.customer_details.email ? this.state.customer_details.email : "NA"}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.0089 4.47514C10.6135 4.59306 11.1691 4.88865 11.6047 5.32407C12.0403 5.7595 12.336 6.31495 12.454 6.91934M10.0089 2C11.265 2.1395 12.4364 2.70181 13.3306 3.59461C14.2249 4.48742 14.7889 5.65764 14.93 6.91315M14.311 11.8511V13.7074C14.3117 13.8797 14.2764 14.0503 14.2073 14.2082C14.1382 14.3661 14.037 14.5079 13.9099 14.6244C13.7829 14.7409 13.6329 14.8296 13.4696 14.8848C13.3063 14.94 13.1332 14.9605 12.9615 14.945C11.0567 14.7381 9.22704 14.0874 7.61947 13.0453C6.12383 12.0953 4.85578 10.8277 3.90539 9.3326C2.85925 7.71832 2.20821 5.8804 2.00502 3.96774C1.98956 3.79662 2.0099 3.62416 2.06476 3.46134C2.11962 3.29851 2.20779 3.14889 2.32367 3.022C2.43955 2.8951 2.58058 2.79372 2.73781 2.7243C2.89503 2.65488 3.06498 2.61895 3.23686 2.61878H5.0939C5.39431 2.61583 5.68554 2.72217 5.91332 2.91799C6.1411 3.1138 6.28987 3.38574 6.33192 3.68309C6.4103 4.27717 6.55566 4.86047 6.76523 5.42188C6.84851 5.64336 6.86654 5.88406 6.81717 6.11546C6.7678 6.34687 6.6531 6.55927 6.48667 6.72752L5.70053 7.51337C6.58173 9.06253 7.86488 10.3452 9.4146 11.2261L10.2007 10.4402C10.369 10.2739 10.5815 10.1592 10.813 10.1099C11.0445 10.0605 11.2853 10.0785 11.5069 10.1618C12.0685 10.3713 12.652 10.5166 13.2463 10.5949C13.547 10.6373 13.8216 10.7887 14.0179 11.0203C14.2142 11.2519 14.3185 11.5476 14.311 11.8511Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Contact Number</div>
                                        <div class="bottom-text">{this.state.customer_details.mobile ? this.state.customer_details.mobile : "NA"}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.6665 6.66667C14.6665 11.3333 8.6665 15.3333 8.6665 15.3333C8.6665 15.3333 2.6665 11.3333 2.6665 6.66667C2.6665 5.07537 3.29864 3.54925 4.42386 2.42403C5.54908 1.29881 7.07521 0.666672 8.6665 0.666672C10.2578 0.666672 11.7839 1.29881 12.9091 2.42403C14.0344 3.54925 14.6665 5.07537 14.6665 6.66667Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M8.6665 8.66667C9.77107 8.66667 10.6665 7.77124 10.6665 6.66667C10.6665 5.5621 9.77107 4.66667 8.6665 4.66667C7.56193 4.66667 6.6665 5.5621 6.6665 6.66667C6.6665 7.77124 7.56193 8.66667 8.6665 8.66667Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Address</div>
                                        <div class="bottom-text cap-text">{this.state.customer_details.country_name && this.state.customer_details.city_name ? this.state.customer_details.city_name + ' (' + this.state.customer_details.country_name + ')' : "NA"}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-box">
                                    <div class="icon-box">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.0002 2.66667H3.66683C2.93045 2.66667 2.3335 3.26363 2.3335 4.00001V13.3333C2.3335 14.0697 2.93045 14.6667 3.66683 14.6667H13.0002C13.7365 14.6667 14.3335 14.0697 14.3335 13.3333V4.00001C14.3335 3.26363 13.7365 2.66667 13.0002 2.66667Z" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M11 1.33333V3.99999" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M5.66699 1.33333V3.99999" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M14.3334 6.66666H2.33339C2.2223 5.44444 2.50014 3.89999 4.50014 3.49999C6.50014 3.09999 10.6668 3.33332 12.5001 3.49999L13.5001 3.5L14.3334 6.66666Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                    <div class="only-text">
                                        <div class="top-text">Account Manager</div>
                                                                                            <div class="bottom-text cap-text">{this.state.account_manager ? <Link to={`/viewEmployee/${this.state.account_manager.id}`} name={"max"} target="_blank"> {this.state.account_manager.name} </Link> : 'NA'}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                                            
                                                                    <div class="product-tab">
                    <div class="row">
                                                                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                                <ul class="nav nav-tabs" role="tablist">
                                                                                    {this.state.products.map((data, key) => (
                                                                                            <li role="presentation" className={key === 0 ? "active" : ""} key={key}><a href="#one" aria-controls="one" role="tab" data-toggle="tab" aria-expanded="true" onClick={() => this.handleTabClick(data)}>{data.product_name ? data.product_name : 'NA'}</a></li>
                                                                                                                    ))}
                                                                                </ul>
                                        </div>
                                        </div>
                                                                        {this.productStore()}
                                        </div>
                                            
                                            
                                            
                                    </div>
                
                <div class="tab-pane no-info-sec" id="AppInfo"><span className="customer-detail-tab">Information not available</span></div>
                <div class="tab-pane no-info-sec" id="Login">
                                 <span className="customer-detail-tab">Information not available</span>    
                                </div>
                                <div class="tab-pane no-info-sec" id="Upload">
                                 <span className="customer-detail-tab">Information not available</span>                 
                                </div>
            </div>
            }
            </div>
                }
                </section>
                </div>
                </div>
                );
    }
}

export default StoreDetails;


// WEBPACK FOOTER //
// ./src/components/customer/StoreDetails.js